import { post } from 'aws-amplify/api';
import { featchAuthSession, fetchAuthSession } from 'aws-amplify/auth';
import store from '../store';

export const newAPIPost = async(p_path, p_body) => {
   try {
      console.log(`path: ${p_path} p_body: ${JSON.stringify(p_body)}`);
      //return path;
       const currentSession = await fetchAuthSession();
       console.log(`current session: ${JSON.stringify(currentSession)}`);
       var p_token = '';
       if (currentSession.tokens && currentSession.tokens.accessToken)
       {
          const accessToken = currentSession.tokens.accessToken.toString();
          //const deviceKey = currentSession.tokens.deviceKey.toString();
          p_token = accessToken;
          console.log('Access Token:', accessToken);
          //console.log('device key:',deviceKey);
       }
       const clientInformation = {
           accessToken: p_token,
           deviceKey: ''
       }
       store.commit('updateCallingApi', { apiPath: p_path, calling: true });
       store.commit('updateApiError', { apiPath: p_path, error: null});
       store.commit('updateGlobalError', null);
       
       if (p_body == null)
       {
          p_body = {};
       }
       const restOperation = await post({
          apiName: 'NamedAccont',
          path: p_path,
          options: {
             body: {request: p_body, clientInformation}
          }
       });
       //return path;
       console.log(`restOperation: ${JSON.stringify(restOperation)}`);
       const { body } = await restOperation.response;
       const response = await body.json();
       console.log('post all successed');
       // console.log(response);
       store.commit('updateCallingApi', { apiPath: p_path, calling: false });
       //return response.data;
       return new Promise((resolve, reject) => {
          try
          {
            if (response && response.success == true)
            {
               console.log(`api no issue with data return: ${JSON.stringify(response.data)}`);
               return resolve(response.data);
            } else {
               if (response.debugCode == 403)
               {
                   alert('Logged in to another device, will logout');
                   return store.dispatch('logout');
               } else {
                  console.log(`return reject api error: ${response.messages} with path: ${p_path}`);
                  store.commit('updateApiError', { apiPath: p_path, errorRes: response});
                  //return reject(body);
                  return reject(response);
               }
            }
          } catch (err) {
             console.log('api:',err);
             store.commit('updateCallingApi', { apiPath: p_path, calling: false });
             store.commit('updateGlobalError', err);
             reject(err);
          }
       })
      //  .catch((err) => {
      //     console.log('api:',err);
      //     store.commit('updateCallingApi', { apiPath: p_path, calling: false });
      //     store.commit('updateGlobalError', err);
      //     //reject(err);
      //  })
       ;
   } catch (err) {
      //console.log('post call failed:',JSON.parse(err.response.body));
      console.log('error calling post api:',err);
      store.commit('updateCallingApi', { apiPath: p_path, calling: false });
      store.commit('updateGlobalError', err);
      return false;
   }
};

// export const postApi = async (apiname, path, body) => {
//    try {
//       const restOperation = post({
//           apiname,
//           path,
//           options: {
//              body: { request: body },
//           },
//       });
//       const { body: responseBody } = await restOperation.response;
//       const data = await responseBody.json();
//       return data;
//    } catch (err)
//    {
//      console.log('API Post Error:'. err);
//      throw err;
//    }
// };


// export default {
//    methods: {
//      async amplifyPost(path, body, options = {}) {
//       try {
//          const restOperation = post('NamedAccont', path, {
//             body,
//             ...options,
//          });
//          const { body: responseBody } = await restOperation.response;
//          return await responseBody.json();
//       } catch (err) {
//          console.log('API POST error:', err);
//          throw err;
//       }
//      },
//    },
// };